module.exports = __webpack_public_path__ + "cf5ba39.ttf";